import Alpine   from 'alpinejs';
import collapse  from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';

import './slick.js';
import './carousel.js';
import './header.js';
import './hero-bg.js';
import './relevanssi.js';
import './resize-guard.js';
import './popup-maker-fix.js';
import { initMapPinchZoom } from './map-pinch-zoom.js';

Alpine.plugin( collapse );
Alpine.plugin( intersect );

Alpine.store( 'scroll', {
	past400: false,
	init() {
		window.addEventListener( 'scroll', () => {
			this.past400 = 400 < window.scrollY;
		}, { passive: true });
	},
});

Alpine.start();

document.addEventListener( 'DOMContentLoaded', initMapPinchZoom );
